module.exports = __webpack_public_path__ + "img/circle.b85b85cf.svg";